import { render, staticRenderFns } from "./CompetitionFilterMyFilter.vue?vue&type=template&id=196fdf4f&scoped=true"
import script from "./CompetitionFilterMyFilter.vue?vue&type=script&lang=js"
export * from "./CompetitionFilterMyFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fdf4f",
  null
  
)

export default component.exports